// extracted by mini-css-extract-plugin
export var fixedImage = "page_inicio-module--fixedImage--B29fw";
export var fixedImageSpacer = "page_inicio-module--fixedImageSpacer--9DOXL";